import BaseComponent from '../base_component/base_component'

export default class Loading extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);

        document.addEventListener('ComponentRendered', event => {
            if (event.componentId !== options.content) return;
            $(this.component).find('>.loading_bar').hide();
        })

    }
}